// accepts data=[{id: '', name: '', content: ''}], label=""
/* eslint-disable react/jsx-indent */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import defaultPhoto from 'assets/img/image-placeholder.jpg';
import Img from 'modules/common/components/Img';

function ViewTabImage({ data, label }) {
  const [requirementTab, setRequirementTab] = useState(0);

  const handleChangeRequirementTab = (location) => () => {
    setRequirementTab(location);
  };

  return (
    <React.Fragment>
      <div className="row mb-3 d-flex align-items-center">
        <div className="col py-0">
          <h3 className="m-0">{label}</h3>
        </div>
      </div>
      <div className="row mb-3">
        {/* TABS */}
        <div className="col-4">
          <div className="form-wrapper arrow-card">
            {!_.isEmpty(data)
              ? data.map((item, i) => (
                  <div
                    key={item.id}
                    role="presentation"
                    className="arrow-cell p-3 btn-blank"
                    onClick={handleChangeRequirementTab(i)}
                  >
                    <div className="font-weight-bold">
                      {_.get(item, 'attributes.name')}
                    </div>
                    {i === requirementTab ? <div className="arrow" /> : ''}
                  </div>
                ))
              : ''}
          </div>
        </div>
        {/* IMAGE HOLDER */}
        <div className="col-8">
          <div className="form-wrapper d-flex justify-content-center overflow-hidden">
            {!_.isEmpty(data) ? ( // CHECK TABLIST IF EMPTY
              <React.Fragment>
                {data.map((
                  item,
                  i // MAP AND CHECK IF ITEM IS EQUAL TO ACTIVE TAB
                ) =>
                  i === requirementTab ? (
                    <React.Fragment key={item.id}>
                      <Img
                        src={_.get(item, 'content')}
                        className="img-fluid shadow-lg"
                        role="presentation"
                        defaultSrc={defaultPhoto}
                        width="90%"
                        alt=""
                      />
                    </React.Fragment>
                  ) : (
                    ''
                  )
                )}
              </React.Fragment>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

ViewTabImage.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired,
  label: PropTypes.string.isRequired,
};

export default ViewTabImage;
